module.exports = __webpack_public_path__ + "img/4-a-squoll-participant-reponse-sondage-md.83ff8850.png";